import { gql } from '@apollo/client'

const METADATA_NODE_FRAGMENT = gql`
  fragment MetadataNodeFragment on MetadataNode {
    id
    name
    idPath
    namePath
    isCurationEnabled
    level

    ... on DishTypeNode {
      isIgnored
      courseTypeNode {
        id
        name
      }
    }

    ... on CuisineTypeNode {
      isErrorProne
    }

    ... on CourseTypeNode {
      isIgnored
      dishTypeNode {
        id
        name
      }
    }

    children {
      id
      name
      idPath
      namePath
      isCurationEnabled
      level

      ... on CuisineTypeNode {
        isErrorProne
      }

      children {
        id
        name
        idPath
        namePath
        isCurationEnabled
        level

        ... on CuisineTypeNode {
          isErrorProne
        }
      }
    }
  }
`

export default METADATA_NODE_FRAGMENT
